export default "__VITE_ASSET__CgUBrEwl__"